import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
/**
 * Endpoint for creating a new guest session.
 * Creates a guest entity and returns a signed token for authentication.
 */
export const GuestCreateEndpoint = defineEndpoint({
    name: 'GuestCreate',
    output: defineEndpoint.output(),
});
//# sourceMappingURL=GuestCreateEndpoint.js.map